import { Document, Font, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { IErgebnis } from "../util/types";

const styles = StyleSheet.create({
  page: {
    size: "A4",
    padding: 0,
    position: "relative",
    fontFamily: "LeckerliOne",
  },
  textContainer: {
    position: "absolute",
    left: 170,
    top: 0,
    width: 400,
  },
  datum: {
    position: "absolute",
    top: 150,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 20,
    color: "#000000",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 595,
    height: 842,
    zIndex: -1,
  },
  beimLauf: {
    position: "absolute",
    top: 430,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 20,
    color: "#000000",
  },
  disziplin: {
    position: "absolute",
    top: 470,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 22,
    color: "#000000",
  },
  erreichte: {
    position: "absolute",
    top: 520,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 20,
    color: "#000000",
  },
  name: {
    position: "absolute",
    top: 560,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 30,
    color: "#000000",
  },
  eineZeitVon: {
    position: "absolute",
    top: 620,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 20,
    color: "#000000",
  },
  time: {
    position: "absolute",
    top: 660,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 25, 
    color: "#000000",
  },
  platzierung: {
    position: "absolute",
    top: 710,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 35,
    color: "#000000",
    fontFamily: "BungeeInline",
  },
  heute: {
    position: "absolute",
    top: 790,
    left: 250,
    right: 0,
    textAlign: "left",
    fontSize: 12,
    color: "#000000",
  },
});

type Props = {
  ergebnis: IErgebnis,
  mitPlatzierung: boolean,
};


Font.register({
  family: "LeckerliOne",
  fonts: [
    {
      src: "/fonts/LeckerliOne-Regular.ttf",
      fontWeight: "bold",
    },
  ],
});
Font.register({
  family: "BungeeInline",
  fonts: [
    {
      src: "/fonts/BungeeInline-Regular.ttf",
    },
  ],
});
const getMsToTime = (ms: number) => {
  ms = Math.round(ms / 1000);
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return (hours < 10 ? '0' : '') + hours + ":" + 
         (minutes < 10 ? '0' : '') + minutes + ":" + 
         (seconds < 10 ? '0' : '') + seconds;
}

export const UrkundePdf = (props: Props) => {
  if (!props.ergebnis) return null;

  function isKinderUrkunde() {
    return props.ergebnis.distanzMeter < 1000 && props.ergebnis.disziplin.toLowerCase().startsWith("u");
  }

  function getTextGeschlecht(){
    if (isKinderUrkunde() && props.ergebnis.geschlecht === "m") return "Jungen";
    if (isKinderUrkunde() && props.ergebnis.geschlecht === "w") return "Mädchen";
    if (!isKinderUrkunde() && props.ergebnis.geschlecht === "m") return "Männer";
    if (!isKinderUrkunde() && props.ergebnis.geschlecht === "w") return "Frauen";
  }

  function getURL(urkundentyp: string, geschlecht: string) {
    if (isKinderUrkunde())
      urkundentyp = "K";
      
    if (urkundentyp === "E")
      if (geschlecht === "m")
        return "/img/urkunde_erwachsene_m.png"
      else
        return "/img/urkunde_erwachsene_w.png"

    if (urkundentyp === "K")
      if (geschlecht === "m")
        return "/img/urkunde_kinder_m.png"
      else
        return "/img/urkunde_kinder_w.png"
  }

  function getPlatzierungstext() {
    if (!props.mitPlatzierung) return "";
    var test = "" + props.ergebnis.ranglistenPlatz;
    return "den " + test + ". Platz";
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.textContainer}>
          <Text style={styles.datum}>{new Date(props.ergebnis.datum).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })}</Text>
          <Text style={styles.beimLauf}>Beim Lauf</Text>
          <Text style={styles.disziplin}>{props.ergebnis.disziplin} ( {getTextGeschlecht()} )</Text>
          <Text style={styles.erreichte}>erreichte</Text>
          <Text style={styles.name}>{props.ergebnis.name}</Text>
          <Text style={styles.eineZeitVon}>{props.mitPlatzierung ? "in einer Zeit von" : "eine Zeit von"}</Text>
          <Text style={styles.time}>{getMsToTime(props.ergebnis.ms)}</Text>
          <Text style={styles.platzierung}>{getPlatzierungstext()}</Text>
          <Text style={styles.heute}>Neermoor, {new Date().toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })}</Text>
        </View>
        <Image src={getURL(props.ergebnis.urkundentyp, props.ergebnis.geschlecht)} style={styles.background} />
      </Page>
    </Document>
  );
};